// src/pages/products/ProductsSkeleton.jsx
import React from 'react';

const SkeletonRow = () => (
  <tr>
    <td>
      <div className="skeleton skeleton-cell" />
    </td>
    <td>
      <div className="skeleton skeleton-cell" />
    </td>
    <td>
      <div className="skeleton skeleton-cell" />
    </td>
    <td>
      <div className="skeleton skeleton-cell" />
    </td>
    <td>
      <div className="skeleton skeleton-cell" />
    </td>
  </tr>
);

export default function ProductsSkeleton() {
  return (
    <>
      {/* فرم افزودن */}
      <div className="card">
        <div className="skeleton skeleton-title" />
        <div className="grid">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="skeleton-field">
              <div className="skeleton skeleton-label" />
              <div className="skeleton skeleton-input" />
            </div>
          ))}
        </div>
        <div className="flexend">
          <div className="skeleton skeleton-btn" />
        </div>
      </div>

      {/* لیست */}
      <div className="card">
        <div className="skeleton skeleton-title" />
        <table>
          <thead>
            <tr>
              <th>کد</th>
              <th>شرح کالا</th>
              <th>واحد</th>
              <th>مبلغ واحد</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {[1, 2, 3, 4, 5].map((i) => (
              <SkeletonRow key={i} />
            ))}
          </tbody>
        </table>
      </div>

      <style>{`
        .skeleton {
          background: linear-gradient(
            90deg,
            var(--border) 25%,
            var(--border-strong) 50%,
            var(--border) 75%
          );
          background-size: 200% 100%;
          animation: skeleton-shimmer 1.4s ease-in-out infinite;
          border-radius: 8px;
        }
        @keyframes skeleton-shimmer {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
        .skeleton-title {
          height: 22px;
          width: 40%;
          margin-bottom: 20px;
        }
        .skeleton-field {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }
        .skeleton-label {
          height: 13px;
          width: 40%;
        }
        .skeleton-input {
          height: 42px;
          width: 100%;
          border-radius: 10px;
        }
        .skeleton-btn {
          height: 44px;
          width: 180px;
          border-radius: 10px;
        }
        .skeleton-cell {
          height: 18px;
          width: 80%;
          margin: 0 auto;
        }
      `}</style>
    </>
  );
}
